(function (angular, app) {
   "use strict";

   angular.module(app.modules.ui.name)
      .controller(app.modules.ui.controllers.checkout, CheckoutController);

   // Injector  
   CheckoutController.$inject = ["$scope"
   , app.modules.ui.services.ui
   , app.modules.common.services.functions
   , app.modules.common.constants.appsettings
   ];

   function CheckoutController($scope
      , ggUISvc
      , ggFunctions
      , ggSettings
      ) {

      // app.Member.Session.appSetup.isStripeTestMode = true;
      var ctrl = this;

      $scope.Temp = {
         window: ggFunctions.fetchWindowSize()
         , storeItem: null
          , branding : app.Branding
      }

      var storeItem = null;

      if ($scope.$parent && $scope.$parent.ngDialogData) {
         storeItem = $scope.$parent.ngDialogData;
         $scope.Temp.storeItem = storeItem;
      }

      $scope.Content = {
         checkout : {
            alert: ""
            , form: {
               cardNumber: ""
               , cvc: null
               , expiry: null
               , productId: storeItem.id
               , clubId: storeItem.clubId
               , clubName: storeItem.clubName
               , description: storeItem.description
               , amount: angular.copy(storeItem.amount)
               , quantity: "1"
                , name: app.Member.Detail.firstName + ' ' + app.Member.Detail.lastName
                , email : app.Member.Detail.email
                , address: app.Member.Detail.address.line1
                , city: app.Member.Detail.address.city
                , region: app.Member.Detail.address.region
                , postalCode: app.Member.Detail.address.postalCode
                , phone: app.Member.Detail.mobilePhone
            }
            , submit: function () {
               if (app.Member.Session.appSetup && !app.Member.Session.appSetup.isStripeTestMode) {
               Stripe.setPublishableKey(app.Branding.stripe.live);
            } else {
                   Stripe.setPublishableKey(app.Branding.stripe.test);
            }

            var expiry = ($scope.Content.checkout.form.expiry).toString();
            var ccNumber = (($scope.Content.checkout.form.cardNumber).trim()).replace(/ /g, '');
            var ccMonth = (expiry).substring(0, 2);
            var ccYear = (expiry).substring(2, 4);
            var ccCvc = $scope.Content.checkout.form.cvc;
            var ccZip = $scope.Content.checkout.form.postalCode;

            var form = {
                name: $scope.Content.checkout.form.name
               , number: ccNumber
               , exp_month: ccMonth
               , exp_year: ccYear
               , cvc: ccCvc
               , address_zip: ccZip
            }

            $scope.Temp.isProcessing = true;
            Stripe.card.createToken(form, function (status, token) {

               if (status == 200) {

                  // Token Received.  Send to Server and charge card.
                  var form = {

                    amount: $scope.Content.checkout.form.amount
                    , quantity: $scope.Content.checkout.form.quantity
                    , clubId: storeItem.clubId || 0
                    , clubName: storeItem.clubName || ''
                    , description: storeItem.description + (storeItem.clubName == '' ? '' : ' - ' + storeItem.clubName)
                    , discountCode: storeItem.discountCode || ''
                    , sourceItemId: storeItem.sourceItemId
                    , token : token.id
                    , cardId : token.card.id
                    , postalCode: token.card.address_zip
                    , productId: storeItem.productId
                    , paySiteId : app.Branding.siteId
                    , isTestMode: app.Member.Session.appSetup.isStripeTestMode ? 1 : 0
                    , phone: $scope.Content.checkout.form.phone
                    , email: $scope.Content.checkout.form.email
                    , name: $scope.Content.checkout.form.name
                    , address: $scope.Content.checkout.form.address
                    , city: $scope.Content.checkout.form.city
                    , region: $scope.Content.checkout.form.region
                  }

                  var insertPayment = app.Member.Network.InsertStripeBasket;

                  insertPayment(form).then(function (data) {
                     if (storeItem.callback) {
                        storeItem.callback({ msg: data.data.msg });
                     }
                  }, function (fail) {
                     $scope.Content.checkout.alert = fail.data.error.msg;
                  }).finally(function () {
                     $scope.Temp.isProcessing = false;
                  });
               } else {
                  $scope.Temp.isProcessing = false;
                  $scope.Content.checkout.alert = token.error.message;
                  $scope.$apply();
               }
            });

            }
            , updateQty: function () {
               $scope.Content.checkout.form.amount = storeItem.amount * $scope.Content.checkout.form.quantity
            }
         }
         
      }

   }
}(angular, app));
